import Dialog from "@imminently/decisively-ui/Dialog";
import { DialogHeader } from "@/ui/dialogs/DialogHeader";

export type CreateProjectPromptProps = {
  close: () => void;
  onCreateProject: () => void;
  onViewProjects: () => void;
};

export const CreateProjectPrompt = ({ close, onCreateProject, onViewProjects }: CreateProjectPromptProps) => {
  const handleCreateProject = () => {
    close();
    onCreateProject();
  };

  const handleViewProjects = () => {
    close();
    onViewProjects();
  };

  return (
    <Dialog.Content className="flex flex-col">
      <DialogHeader
        title="Create project"
        description="Build does not work without an active project. Please create one now."
      />
      <Dialog.Actions>
        <Dialog.Actions.SecondaryButton
          onClick={handleViewProjects}
          label="Projects"
        >
          Projects
        </Dialog.Actions.SecondaryButton>
        <Dialog.Actions.PrimaryButton
          onClick={handleCreateProject}
          label="Create project"
        >
          Create project
        </Dialog.Actions.PrimaryButton>
      </Dialog.Actions>
    </Dialog.Content>
  );
};
